<template>
    <div class="content">
        <p class="title">{{value.title}}</p>
        <div ref="echart" class="echart"></div>
    </div>
</template>

<script>
import echarts from 'echarts'

export default {
  name: 'theBarChart',
  props: {
    value: Object
  },
  watch: {
    'value': {
      handler (newValue) {
        if (newValue) {
          setTimeout(() => {
            if (!this.echart) {
              this.echart = echarts.init(this.$refs['echart'])
              this.echart.setOption(
                this.option
              )
              window.addEventListener('resize', () => {
                this.echart.resize()
              })
            }
            this.echart.hideLoading()
            this.changeEchart()
          })
        }
      },
      deep: true,
      immediate: true
    }
  },
  data () {
    return {
      option: {
        color: '#67D6B1',
        grid: {
          top: 30,
          left: 10,
          right: '5%',
          bottom: 10,
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              color: '#fff'
            }
          },
          formatter: (objs, index) => {
            let obj = objs[0]
            return `${obj.name}: ${obj.value} `
          }
        },
        legend: {
          show: false
        },
        xAxis: {
          type: 'category',
          data: [],
          axisLabel: {
            color: '#909399'
          },
          axisLine: {
            lineStyle: {color: '#909399'}
          },
          axisTick: {
            show: false
          }
        },
        yAxis: {
          splitLine: {
            show: false,
            lineStyle: {
              type: 'dashed'
            }
          },
          axisLabel: {
            color: '#909399',
            formatter: function (value, index) {
              if ((index % 2) === 0) {
                return value
              } else if (isNaN(index)) {
                return value
              } else {
                return ''
              }
            }
          },
          axisLine: {
            lineStyle: {color: '#909399'}
          },
          axisTick: {
            show: false
          }
        },
        series: [{
          type: 'bar',
          barMaxWidth: '16px',
          itemStyle: {
            normal: {
              color: '#208EFF'
            }
          },
          data: []
        }
        ]
      },
      echart: null
    }
  },
  created () {
    this.loadingSetting()
  },
  methods: {
    // 输入新值 渲染
    changeEchart () {
      if (!this.value.data.series || !this.value.data.series[0].data || !this.value.data.series[0].data.length) {
        this.echart.showLoading('nodatas')
      }
      this.echart.setOption({
        yAxis: this.value.data.yAxis,
        xAxis: this.value.data.xAxis,
        series: this.value.data.series
      })
    },
    loadingSetting () {
      var loadingNodata = function (api, opts) {
        opts = {
          text: 'no data',
          color: '#c23531',
          textSize: 14,
          textColor: 'rgb(153, 153, 153)',
          maskColor: 'rgba(255, 255, 255, 0.8)',
          zlevel: 0
        }
        var mask = new echarts.graphic.Rect({
          style: {
            fill: opts.maskColor
          },
          zlevel: opts.zlevel,
          z: 10
        })
        var labelRect = new echarts.graphic.Rect({
          style: {
            fill: 'none',
            text: opts.text,
            // textPosition: 'right',
            textDistance: 10,
            fontSize: 14,
            textFill: opts.textColor
          },
          zlevel: opts.zlevel,
          z: 11
        })
        var group = new echarts.graphic.Group()
        group.add(labelRect)
        group.add(mask) // Inject resize

        group.resize = function () {
          var cx = api.getWidth() / 2
          var cy = api.getHeight() / 2
          labelRect.setShape({
            x: cx - 10,
            y: cy - 10,
            width: 10 * 2,
            height: 10 * 2
          })
          mask.setShape({
            x: 0,
            y: 0,
            width: api.getWidth(),
            height: api.getHeight()
          })
        }
        group.resize()
        return group
      }
      echarts.registerLoading('nodatas', loadingNodata)
    }
  }
}
</script>

<style lang="scss" scoped>
    .content {
        position: relative;
    }

    .echart {
        width: 100%;
        height: 100%;
    }

    .title {
        position: absolute;
        top: 20px;
        left: 50%;
        transform: translateX(-50%);
        font-size: 12px;
        color: #aaa;
    }


    .title {
        top: 0;
        color: #303133;
        width: 100%;
        text-align: center;
    }
</style>
